export const INDEX_ROUTE = '/';
// Auth routes
export const AUTH_ROUTE = '/auth/';
export const AUTH_OTP_ROUTE = `${AUTH_ROUTE}otp/`;
export const AUTH_ACCOUNT_DETAILS_ROUTE = `${AUTH_ROUTE}account-details/`;
export const AUTH_RESET_PASSWORD_ROUTE = `${AUTH_ROUTE}reset-password/`;

export const ACCOUNT_UPDATE_PASSWORD_ROUTE = '/account/update-password';

export const BARBER_PROFILE_ROUTE = '/:username/';
export const BARBER_PROFILE_REVIEW_ROUTE = `${BARBER_PROFILE_ROUTE}:k?/`;
export const BARBER_BOOKING_SLOT_ROUTE = `${BARBER_PROFILE_ROUTE}time/`;
export const BARBER_WAITING_LIST_START_ROUTE = `${BARBER_PROFILE_ROUTE}waiting-list/start`;
export const BARBER_WAITING_LIST_END_ROUTE = `${BARBER_PROFILE_ROUTE}waiting-list/end`;

export const BARBER_WAITING_LIST_CONFIRMATION_ROUTE = `${BARBER_PROFILE_ROUTE}waiting-list/confirmation`;
export const BARBER_WAITING_LIST_SUCCESS_ROUTE = `${BARBER_PROFILE_ROUTE}waiting-list/success`;
export const BARBER_REFERRER_ROUTE = `${BARBER_PROFILE_ROUTE}refer-friend/`;
export const BARBER_BOOKING_PROMOTION_ROUTE = `${BARBER_PROFILE_ROUTE}promotions/`;
export const BARBER_BOOKING_CALLOUT_ADDRESS_ROUTE = `${BARBER_PROFILE_ROUTE}callout/`;
export const BARBER_BOOKING_CONFIRMATION_ROUTE = `${BARBER_PROFILE_ROUTE}confirmation/`;
export const BARBER_BOOKING_SUCCESS_ROUTE = `${BARBER_PROFILE_ROUTE}:bookingId/success/`;

export const PROMOTION_ROUTE = '/promotions/';
export const MY_BOOKINGS_ROUTE = '/my-bookings/';
export const PAYMENT_METHODS_ROUTE = '/payment-methods/';

export const BARBER_BOOKING_PUBLIC_ROUTE = `/booking${BARBER_PROFILE_ROUTE}:bookingCode`;
